import { HeaderNull } from '../../../component/HeaderNull'
import { useState } from 'react'
import { MatKhauDangNhap } from './MatKhauDangNhap'
import { MatKhauRutTien } from './MatKhauRutTien'

function ThayDoiMatKhau () {
  const [tab, settab] = useState('รหัสผ่านเข้าสู่ระบบ')
  const data = [
    {
      name: 'รหัสผ่านเข้าสู่ระบบ'
    },
    {
      name: 'รหัสผ่านการถอนเงิน'
    }
  ]
  return (
    <div>
      <HeaderNull title={'ปลี่ยนรหัสผ่าน'} link={'/usermobile'} />
      <div style={{ marginTop: '60px' }}>
        <div className='tab_naptien'>
          <div
            className={`tab_panel_van ${
              tab === 'รหัสผ่านเข้าสู่ระบบ' ? 'tab-login' : 'tab-register'
            }`}
          >
            {data.map((item, index) => (
              <div
                className={`tab_panel_tab ${
                  tab === item.name ? 'tab_panel_tab_active' : ''
                } `}
                onClick={() => settab(item.name)}
                key={index}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>

        {tab === 'รหัสผ่านเข้าสู่ระบบ' && <MatKhauDangNhap />}
        {tab === 'รหัสผ่านการถอนเงิน' && <MatKhauRutTien />}
      </div>
    </div>
  )
}

export default ThayDoiMatKhau
